import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Browse by era",
    body: "Collections organized by decade and style — from mid-century lamps to 80s denim. The hunt stays fun; the clutter stays out.",
  },
  {
    n: "02",
    title: "Check authentication",
    body: "Every listing comes from a vetted seller and carries condition notes plus provenance when available. Our review team checks era-appropriate materials before anything goes live.",
  },
  {
    n: "03",
    title: "Buy with confidence",
    body: "Checkout is protected end to end, and every order is covered by buyer protection. Not as described? Full refund, return shipping included.",
  },
];

export default function ManifestoChapters() {
  return (
    <section data-testid="manifesto-section" className="border-t border-[#E2D9CD] bg-[#F3EFE6]">
      <div className="mx-auto max-w-[1600px] px-6 py-24 sm:px-12 lg:px-20 lg:py-32">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mb-16 flex items-center gap-3 font-mono text-[11px] font-medium uppercase tracking-[0.3em] text-[#6B1D2F]"
        >
          <span className="inline-block h-px w-10 bg-[#6B1D2F]" />
          The Manifesto — Antique hunt, without the doubt
        </motion.p>

        <div className="space-y-0">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`manifesto-chapter-${i + 1}`}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group grid grid-cols-12 items-baseline gap-6 border-t border-[#E2D9CD] py-12 transition-colors duration-500 last:border-b hover:bg-[#FAF6F0]/60 lg:py-16"
            >
              <div className="col-span-3 sm:col-span-2">
                <span className="font-serif text-5xl italic text-[#C59B27] transition-colors duration-500 group-hover:text-[#6B1D2F] sm:text-6xl lg:text-7xl">
                  {c.n}
                </span>
              </div>
              <h3 className="col-span-9 font-serif text-2xl tracking-tight text-[#1C1815] sm:col-span-4 sm:text-3xl lg:text-4xl">
                {c.title}
              </h3>
              <p className="col-span-12 max-w-md text-base leading-relaxed text-[#5C544D] sm:col-span-5 sm:col-start-8 lg:text-lg">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
